import { DefaultTheme } from 'styled-components';

const typography: DefaultTheme['typography'] = {
  super: '100px',
  hero: '64px',
  heroMobile: '40px',
  h1: '48px',
  h1Small: '40px',
  h2Bigger: '32px',
  h2: '24px',
  h2Small: '20px',
  h3: '16px',
  h4: '14px',
  span: '12px',
  small: '10px',
  sectionTitle: '18px',
  lpHeaderTitleSize: '30px',
  lpHeaderTitleLineHeight: '36px',
  lpHeaderSubtitleLineHeight: '22px',
  lpHeaderTitleLaptop: '40px',
};

export default typography;
